import React, { useState } from 'react';
import { FacebookIcon, MessageCircleIcon } from 'lucide-react';
import { GENERAL_ENQUIRY_URL, WHATSAPP_DISPLAY } from '../../utils/whatsapp';
import { PolicyModal } from '../PolicyModal';
import { legalDocuments, type LegalDocument } from '../../data/policies';
export function SiteFooter() {
  const [activeDocument, setActiveDocument] = useState<LegalDocument | null>(null);
  return <>
      <footer className="bg-navy" data-id="element-31" data-mp="1lpgrz88c0ccq">
        <div className="mx-auto max-w-7xl px-5 py-10 sm:px-8" data-id="element-32" data-mp="1lmcetlcw269x">
          <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between" data-id="element-33" data-mp="1qmgxni19rd3b">
            <div data-id="element-34" data-mp="1cmpc8w8faufa">
              <p className="font-brand text-xl italic tracking-tight text-ivory" data-id="element-35" data-mp="1cn7fwdxf0ax8">
                Jam Fragrances<span className="text-lime" data-id="element-36" data-mp="1gnrd1hhznejd">.</span>
              </p>
              <div className="mt-3 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-ivory/70" data-id="element-37" data-mp="18c3yzq5knkd">
                <a href={GENERAL_ENQUIRY_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 transition-colors duration-200 ease-smooth hover:text-lime" data-id="element-38" data-mp="5afg7qknbw6p">
                  <MessageCircleIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-39" data-mp="26vx0lpyf4zzs" />
                  WhatsApp {WHATSAPP_DISPLAY}
                </a>
                <a href="https://www.facebook.com/profile.php?id=61592477107032" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 transition-colors duration-200 ease-smooth hover:text-lime" data-id="element-40" data-mp="22ts66p05bzc3">
                  <FacebookIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-41" data-mp="2qjmhv38qbhur" />
                  Jam Fragrances en Facebook
                </a>
              </div>
            </div>

            <nav aria-label="Información legal" data-id="element-42" data-mp="2zlvtjwfqhh9q">
              <ul className="flex flex-wrap gap-x-6 gap-y-2 text-xs text-ivory/70" data-id="element-43" data-mp="2zihuax2d9o6i">
                {legalDocuments.map(doc => <li key={doc.id} data-id="element-44" data-mp="1s94kbwr40phi">
                    <button type="button" onClick={() => setActiveDocument(doc)} className="underline-offset-4 transition-colors duration-200 ease-smooth hover:text-lime hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-45" data-mp="1sa67v0pbb4g4">
                      {doc.label}
                    </button>
                  </li>)}
              </ul>
            </nav>
          </div>

          <p className="mt-8 border-t border-ivory/10 pt-6 text-xs text-ivory/50" data-id="element-46" data-mp="2fwcq0fsga0k2">
            © {new Date().getFullYear()} Jam Fragrances
          </p>
        </div>
      </footer>

      <PolicyModal document={activeDocument} onClose={() => setActiveDocument(null)} data-id="element-47" data-mp="2oxkn4uj8cvck" />
    </>;
}